import { render } from "./ActionLinkItem.vue?vue&type=template&id=a560b944&scoped=true"
import script from "./ActionLinkItem.vue?vue&type=script&lang=js"
export * from "./ActionLinkItem.vue?vue&type=script&lang=js"

import "./ActionLinkItem.vue?vue&type=style&index=0&id=a560b944&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a560b944"]])

export default __exports__